<template>
    <section class="marketing-overview">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="data-box">
            <LineTipsComponent style="width:180px; margin-top:33px;" :lineTipsInfo="lineTipsInfo"></LineTipsComponent>
            <columnar-component style="width:70%;" :columnarData="columnarData"></columnar-component>
        </section>
        <tips-component :info="info"></tips-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .marketing-overview {
        background-color: #FFF;
	    padding: 30px 20px 10px 20px;
        margin-top: 20px;
        .data-box {
            width: 100%;
            height: 255px;
            padding-left: 40px;
            margin-top: 35px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import LineTipsComponent from '../line-tips/LineTips.vue'
    import ColumnarComponent from '../../../components/echarts/Columnar.vue'
    import TipsComponent from '../../../components/tips/Tips.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'
    
    export default {
        components: {
            TitleDateComponent,
            LineTipsComponent,
	        ColumnarComponent,
	        TipsComponent
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '交易商品动销概况',  // 名称
                    dateRadio: false,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    download: true, // 是否显示下载按钮
	                moduleId: 2,
	                bizCode: this.bizCode
                },
	            startDate: MomentFormat.getYestoday(),  // 开始日期，默认昨天
	            endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
	            initDateRange: MomentFormat.getYestoday() + ' ~ ' + MomentFormat.getYestoday(),
	            data: this.resultData
            }
        },
        computed: {
        	// 动销率指标
	        lineTipsInfo () {
	        	return {
			        name: '动销率',
			        value: this.data.payProductRate,
			        unit: '%',
			        compare: this.data.payProductRateChg,
			        title: '有销量的在线商品数／在线商品数'
		        }
	        },

            // 底部建议
	        info () {
	        	return {
			        value: 1,
			        suggest: "动销率是关于商品滞销情况的关键数据。动销率＞100%，说明您备货不足，部分商品缺货，需要更好的及时备货和货品管理；动销＜100%，需要根据商品分析定位和问题，降低滞销商品的数量。"
		        }
	        },

            // 图表数据
	        columnarData () {
	        	return [
			        this.data.payProductNum,
			        this.data.orderProductNum,
			        this.data.viewProductNum,
			        this.data.onlineProductNum
                ]
            }
        },
        props: ["resultData", "bizCode"],
	    watch: {
		    resultData: {
			    handler: function () {
				    this.data = this.resultData;
			    },
			    deep: true
		    }
	    },
        methods: {
	        getData () {
		        DataPlatform.getOperationData(this.bizCode, this.startDate, this.endDate)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.data = res.data;
                        } else {
                            this.data = {};
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        this.data = {};
                        console.log(err);
                    })
	        },

	        // 切换日期
	        changeDate (params) {
		        this.startDate = params.dateRange.startDate;
		        this.endDate = params.dateRange.endDate;
		        this.getData();
	        }
        }
    }
</script>



// WEBPACK FOOTER //
// MarketingOverview.vue?e1157aa0